import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();
export const trackingValueState = atom({
  key: "trackingValueState",
  default: {
    barcode: '',
    scanDate: '',
  },
  effects_UNSTABLE: [persistAtom],
});
